/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
import { lvtMetricEvent } from '../../..';
import ga from '../../../../helpers/ga';
import { pipeline } from '..';
import { LVTMetricCheckoutAnalysisStep } from '../../types';

/* eslint-disable class-methods-use-this */
export class FlowPrimitives {
  addAbandonedCheckoutStepEvent(data: {
    sessionId: string;
    timestamp: number;
    abandonedCheckout: boolean;
    lastStepReached?: string;
  }): void {
    ga.sendEvent(
      ...lvtMetricEvent(
        'checkout_analysis',
        data,
        'abandoned',
        'checkout_abandoned',
        'learning-platform'
      )
    );
  }

  addCheckoutStepEvent(
    stepName: LVTMetricCheckoutAnalysisStep,
    data: {
      sessionId: string;
      timestampEntry?: number;
      timestampExit?: number;
      timeSpent?: number;
      basketId?: string;
    },
    storageStepName?: string
  ): void {
    const [event, enhancedData] = lvtMetricEvent(
      'checkout_analysis',
      data,
      'step',
      stepName,
      'learning-platform'
    );
    ga.sendEvent(event, enhancedData);

    if (storageStepName) {
      pipeline.storage.setSessionStorageItem(
        storageStepName,
        JSON.stringify({ event, data: enhancedData })
      );
    }
  }

  enterNextEvent(
    sessionId: string,
    stepName: LVTMetricCheckoutAnalysisStep,
    options: { saveToStorage?: boolean } = {},
    additionalData = {}
  ): void {
    const timestampEntry = Date.now();
    const basketId =
      pipeline.storage.getSessionStorageItem('basketId') || undefined;

    const data = {
      sessionId,
      timestampEntry,
      basketId,
      ...additionalData,
    };

    pipeline.storage
      .setLocalStorageItem('stepName', stepName)
      .setSessionStorageItem(stepName, String(timestampEntry));

    this.addCheckoutStepEvent(
      stepName,
      data,
      options.saveToStorage ? pipeline.storage.entry(stepName) : undefined
    );
  }

  exitPreviousEvent(
    sessionId: string,
    stepName: LVTMetricCheckoutAnalysisStep,
    options: { saveToStorage?: boolean } = {}
  ): void {
    const timestampExit = Date.now();
    const prevTimestamp = Number(
      pipeline.storage.getSessionStorageItem(stepName)
    );

    const basketId =
      pipeline.storage.getSessionStorageItem('basketId') || undefined;

    const data = {
      sessionId,
      timestampExit,
      timeSpent: prevTimestamp ? timestampExit - prevTimestamp : undefined,
      basketId,
    };

    this.addCheckoutStepEvent(
      stepName,
      data,
      options.saveToStorage ? pipeline.storage.exit(stepName) : undefined
    );
  }
}
